import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IChannel } from 'src/app/models/interfaces/channel.interface';
import { CustomerIdentificationFormContext } from './tabs/customer-identification/customer-identification-form-context';

export class ChannelDetailContext extends DefaultDetailContext<IChannel, number> {
    public CustomerIdentificationContext: CustomerIdentificationFormContext = new CustomerIdentificationFormContext();
}
